import axios from 'axios'
import * as types from './mutations_types'

export default {
    [types.SET_TOKEN] (state, token) {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
        state.token = token
    },
    [types.SET_SHOW_TOUR] (state, showTour) {
        state.showTour = showTour
    },
    [types.CLEAR_STATE] (state) {
        state.token = ''
        state.showTour = false
    }
}



// WEBPACK FOOTER //
// ./src/modules/auth/store/mutations.js